module.exports = __webpack_public_path__ + "media/images/ic-checked-ab679c169231346de71d282faab6e5ee.svg";